import { Component } from 'react';
import { PropTypes } from 'prop-types';
import queryString from 'query-string';


class QueryToState extends Component {
  componentDidMount() {
    const { history } = this.props;

    this.dispatchToStoreFromQuery(history.location.search, true);

    this.unlisten = history.listen((location) => {
      this.dispatchToStoreFromQuery(location.search);
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  comparisonDateRangesAreEqual = (a, b) => a && b
    && a.comparisonId === b.comparisonId
    && a.startDate === b.startDate
    && a.endDate === b.endDate
    && a.locationId === b.locationId
    && a.option === b.option;

  dispatchToStoreFromQuery = (query, init = false) => {
    const {
      selectLocationOnLoad,
      selectReportOnLoad,
      setDateRange,
      setComparisonDateRange,
      setFilterOption,
      setInApp,
      setUseDefaultDateRange,
      selectLocation,
      selectReport,
      locations,
      selectedReport,
      selectedLocation,
      setDebug,
      dateRange,
      inApp: currInApp, comparisonDateRanges,
      loadLocations,
    } = this.props;

    const {
      locationId,
      reportId,
      startDate,
      endDate,
      comparisonDateRanges: cdrString,
      in_app: inApp,
      debug,
      ...others
    } = queryString.parse(query,
      { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true });

    if (locations.length > 0) {
      if (locationId && locationId !== selectedLocation.id) {
        selectLocation(locationId);
      }

      if (reportId && reportId !== selectedReport.reportID) {
        selectReport(reportId);
      }
    } else {
      if (locationId) {
        selectLocationOnLoad(locationId);
      }

      if (reportId) {
        selectReportOnLoad(reportId);
      }
    }

    if (init) {
      loadLocations(locationId);
    }

    if (startDate && endDate && startDate !== dateRange.startDate && endDate !== dateRange.endDate) {
      setDateRange({ startDate, endDate });
      setUseDefaultDateRange(false);
    }

    if (cdrString) {
      const newComparisonDateRanges = JSON.parse(cdrString);
      newComparisonDateRanges.forEach((cdr) => {
        if (!this.comparisonDateRangesAreEqual(cdr, comparisonDateRanges.find(x => x.comparisonId === cdr.comparisonId))) {
          setComparisonDateRange(cdr);
        }
      });
    }

    if (inApp && inApp !== currInApp) {
      setInApp(inApp);
    }

    if (debug) {
      setDebug(true);
    }


    Object.entries(others).forEach((entry) => {
      setFilterOption({ key: entry[0], value: entry[1] });
    });
  }

  render() {
    return null;
  }
}

QueryToState.propTypes = {
  history: PropTypes.object.isRequired,
  locations: PropTypes.array,
  selectedLocation: PropTypes.object,
  selectedReport: PropTypes.object,
  dateRange: PropTypes.object,
  comparisonDateRanges: PropTypes.array,
  inApp: PropTypes.bool.isRequired,
  selectReport: PropTypes.func.isRequired,
  selectLocation: PropTypes.func.isRequired,
  selectLocationOnLoad: PropTypes.func.isRequired,
  selectReportOnLoad: PropTypes.func.isRequired,
  setDateRange: PropTypes.func.isRequired,
  setComparisonDateRange: PropTypes.func.isRequired,
  setFilterOption: PropTypes.func.isRequired,
  setInApp: PropTypes.func.isRequired,
  setUseDefaultDateRange: PropTypes.func.isRequired,
  loadLocations: PropTypes.func.isRequired,
};

QueryToState.defaultProps = {
  locations: [],
  selectedLocation: null,
  selectedReport: null,
  dateRange: null,
  comparisonDateRanges: [],
};

export default QueryToState;
